/* eslint-disabled */

export default class ReductionModelExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
